<template>
  <div class="videopage photopage">
    <v-menu></v-menu>
    <mode v-if="loadMode"></mode>
    <div class="pagebg">
      <div class="downpage">
        <div class="data_main" v-show="down1.bookList.length>0||down1.audioList.length>0||down1.videoList.length">
          <div class="data-top">
            <div class="down_title left">心密资料下载</div>
            <div class="left tabgroup left">
              <div class="left tab" :class="{'select':down1.select==0}" @click="tabList(0)">文字</div>
              <div class="left tab" :class="{'select':down1.select==1}" @click="tabList(1)">音频</div>
              <div class="left tab" :class="{'select':down1.select==2}" @click="tabList(2)">视频</div>
              <div class="clear clearfix"></div>
            </div>
            <div class="clear clearfix"></div>
          </div>
          <vuescroll :ops="ops" ref="vs">
            <div class="book-list left">
              <div class="listcolumn filelist" v-if="down1.select==0">
                <div class="fileitem left" v-for="item in down1.bookList">
                  <div class="fileitem_box">
                    <div class="left filename textover">《{{item.className}}》</div>
                    <div class="right down" @click="downFile(item)">下载</div>
                    <div class="clear clearfix"></div>
                  </div>
                </div>
                <div class="fileitem left">
                  <div class="fileitem_box">
                    <div class="left filename textover">《2023整理校对文集(含书单)》</div>
                    <a class="right down" download href="http://hljsyxjs.net/2023整理校对文集(含书单).zip" target="_blank">下载</a>
                    <div class="clear clearfix"></div>
                  </div>
                </div>
              </div>
              <div class="listcolumn audiolist" v-if="down1.select==1">
                <div class="fileitem left" v-for="item in down1.audioList">
                  <div class="fileitem_box">
                    <div class="left filename textover">《{{item.className}}》</div>
                    <div class="right down" @click="downFile(item)">下载</div>
                    <div class="clear clearfix"></div>
                  </div>
                </div>
              </div>
              <div class="listcolumn videolist"  v-if="down1.select==2">
                <div class="fileitem left"  v-for="item in down1.videoList">
                  <div class="fileitem_box">
                    <div class="left filename textover">《{{item.className}}》</div>
                    <div class="right down" @click="downFile(item)">下载</div>
                    <div class="clear clearfix"></div>
                  </div>
                </div>
              </div>
            </div>
            <div class="clear clearfix"></div>
          </vuescroll>
        </div>
        <div class="data_main" v-show="down2.bookList.length>0||down2.audioList.length>0||down2.videoList.length">
          <div class="data-top">
            <div class="down_title left">其它资料下载</div>
            <div class="left tabgroup left">
              <div class="left tab" :class="{'select':down2.select==0}" @click="tabListDown(0)">文字</div>
              <div class="left tab" :class="{'select':down2.select==1}" @click="tabListDown(1)">音频</div>
              <div class="left tab" :class="{'select':down2.select==2}" @click="tabListDown(2)">视频</div>
              <div class="clear clearfix"></div>
            </div>
            <div class="clear clearfix"></div>
          </div>
          <vuescroll :ops="ops" ref="vs">
            <div class="book-list left">
              <div class="listcolumn filelist" v-if="down2.select==0">
                <div class="fileitem left" v-for="item in down2.bookList">
                  <div class="fileitem_box">
                    <div class="left filename textover">《{{item.className}}》</div>
                    <div class="right down" @click="downFile(item)">下载</div>
                    <div class="clear clearfix"></div>
                  </div>
                </div>
              </div>
              <div class="listcolumn audiolist" v-if="down2.select==1">
                <div class="fileitem left" v-for="item in down2.audioList">
                  <div class="fileitem_box">
                    <div class="left filename textover">《{{item.className}}》</div>
                    <div class="right down" @click="downFile(item)">下载</div>
                    <div class="clear clearfix"></div>
                  </div>
                </div>
              </div>
              <div class="listcolumn videolist"  v-if="down2.select==2">
                <div class="fileitem left"  v-for="item in down2.videoList">
                  <div class="fileitem_box">
                    <div class="left filename textover">《{{item.className}}》</div>
                    <div class="right down" @click="downFile(item)">下载</div>
                    <div class="clear clearfix"></div>
                  </div>
                </div>
              </div>
            </div>
            <div class="clear clearfix"></div>
          </vuescroll>
        </div>
        <div class="data_main down_main">
          <div class="down_txt left">
            <p>佛法修证心要</p>
            <p>APP下载：</p>
          </div>
          <div class="left towcode">
            <img src="../../../assets/images/appcode.png" alt="app下载" title="app下载">
          </div>
          <div class="downtype left">
            <div class="down_type_box">
              <div class="down-item android">扫码直接下载“佛法修证心要”安卓版</div>
              <div class="down-item ios">打开App Store搜索“佛法修证心要”直接下载</div>
            </div>
          </div>
          <div class="clear clearfix"></div>
        </div>
      </div>
    </div>
    <v-footer></v-footer>
  </div>
</template>

<script>
  import MoPaging from '@/components/page/page'
  import mode from '@/components/bg/mode'
  import vuescroll from 'vuescroll'
  export default {
    name: "index",
    components:{
      MoPaging, mode,vuescroll
    },
    data() {
      return {
        pageSize : 6 , //每页显示6条数据
        currentPage : 1, //当前页码
        count : 100, //总记录数
        loadMode:true,
        ops: {
          vuescroll: {},
          scrollPanel: {},
          rail: {
            opacity: 0,
            size: '10px',
            specifyBorderRadius: false,
            gutterOfEnds: null,
            background:'#c9a168',
            gutterOfSide: '2px',
            keepShow: false
          },
          bar: {
            showDelay: 500,
            onlyShowBarOnScroll: true,
            keepShow: false,
            background: '#c9a168',
            opacity: 1,
            hoverStyle: false,
            specifyBorderRadius: false,
            minSize: 0.2,
            size: '10px',
            disable: false,
          },

        },
        down1:{
          select:0,
          bookList:[],
          audioList:[],
          videoList:[]
        },
        down2:{
          select:0,
          bookList:[],
          audioList:[],
          videoList:[]
        },
        fileArr:['txt','pdf','doc','docx'],
        audioArr:['mp3','cda','wav','aif','mid','wma','ra'],
        videoArr:['avi','mov','rmvb','rm','flv','mp4','3gp']
      }
    },
    mounted() {
      this.getDownData()
    },
    methods: {
      getDownData(){
        this.loadMode=true
        this.$http({
          url: '/dense/heart',
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          data: {ajax:1}
        }).then((res) => {
          console.log(res)
          this.getOtherData()
          if(res.data.code==0){
            res.data.data.map((item,index,arr)=>{
              console.log(item)
              var index= item.pdf_content.lastIndexOf(".");
              console.log(index)
              var ext = item.pdf_content.substr(index+1);
              console.log(ext)
              if(this.fileArr.indexOf(ext)>=0){
                this.down1.bookList.push(item)
              }
              if(this.audioArr.indexOf(ext)>=0){
                this.down1.audioList.push(item)
              }
              if(this.videoArr.indexOf(ext)>=0){
                this.down1.videoList.push(item)
              }
            })
            console.log(this.down1)
          }else{
            // this.$layer.msg(res.data.msg)
          }
        })
          .catch((error) => {
            // error
            this.$layer.msg('网络错误，请稍后重试')
            this.loadMode=false
            console.log(error)
          })
      },
      getOtherData(){
        this.$http({
          url: '/dense/other',
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          data: {ajax:1}
        }).then((res) => {
          console.log(res)
          this.loadMode=false
          if(res.data.code==0){
            res.data.data.map((item,index,arr)=>{
              console.log(item)
              var index= item.pdf_content.lastIndexOf(".");
              console.log(index)
              var ext = item.pdf_content.substr(index+1);
              console.log(ext)
              if(this.fileArr.indexOf(ext)>=0){
                this.down2.bookList.push(item)
              }
              if(this.audioArr.indexOf(ext)>=0){
                this.down2.audioList.push(item)
              }
              if(this.videoArr.indexOf(ext)>=0){
                this.down2.videoList.push(item)
              }
            })
            console.log(this.down1)
          }else{
            // this.$layer.msg(res.data.msg)
          }
        })
          .catch((error) => {
            // error
            this.$layer.msg('网络错误，请稍后重试')
            this.loadMode=false
            console.log(error)
          })
      },
      tabList(i){
        this.down1.select=i
      },
      tabListDown(i){
        this.down2.select=i
      },
      async downFile(item){
        this.$layer.msg("文件下载中,请稍后",{icon:1});//提示框
        let response = await fetch(item.pdf_content); // 内容转变成blob地址
        console.log(response)
        let blob = await response.blob();  // 创建隐藏的可下载链接
        let objectUrl = window.URL.createObjectURL(blob);
        let a = document.createElement('a');
        a.href = objectUrl;
        a.download = item.className;
        a.click()
        a.remove();
        this.$layer.msg("文件下载成功",{icon:1});
      },
    }
  }
</script>

<style scoped lang="scss">
  .downpage{
    width:95rem;
    margin:0 auto;
    /*padding:0 0 0 9rem;*/
    box-sizing: border-box;
    .data_main{
      background: rgba(201,161,104,0.2);
      border-radius:6px;
      width:100%;
      padding:0 2.8rem 2rem 2.8rem;
      box-sizing: border-box;
      margin-top:2.8rem;
      height:20rem;
      .data-top{
        padding:2rem 0 1.3rem 0;
        .tabgroup{
          margin-left:3rem;
          .tab{
            color:#c9a168;
            line-height:2.2rem;
            margin-left:0.5rem;
            cursor: pointer;
            font-size:1.4rem;
          }
          .select{
            color:#5f4009;
          }
        }
      }
      .down_title{
        color:#5f4009;
        font-size:1.7rem;
        line-height:2.2rem;
      }
      .book-list{
        width:100%;
        .filelist{
          /*padding-right:4.7rem;*/
        }
        .listcolumn{
          width:100%;
          /*border-right:1px dashed #a6906e;*/
          box-sizing: border-box;
          .fileitem:nth-of-type(1){
            margin-top:0;
          }
          .fileitem:nth-child(2n){
            float:right;
          }
        }
        .audiolist{
          width:100%;
          /*padding-left:4.7rem;*/
          /*padding-right:4.7rem;*/
          /*border-right:1px dashed #a6906e;*/
          .fileitem{
            .filename{
              background:url('../../../assets/images/audio.png')no-repeat left center;
              background-size:1.1rem auto;
            }
          }
        }
        .videolist{
          /*padding:0 0 0 4.7rem;*/
          border-right:none;
          .fileitem{
            .filename{
              background:url('../../../assets/images/video.png')no-repeat left center;
              background-size:1.1rem auto;
            }

          }

        }
      }

      .fileitem{
        width:47%;
        /*margin:2rem 0 0 0;*/
        .fileitem_box{
          width:100%;
          box-sizing: border-box;
          border-bottom: 1px dashed #c9a168;
          padding: 0.7rem 0;
          .filename{
            width:60%;
            color:#5f4009;
            font-size:1.3rem;
            padding-left:2rem;
            box-sizing: border-box;
            line-height: 1.7rem;
            background:url('../../../assets/images/book.png')no-repeat left center;
            background-size:1.1rem auto;
          }
          .down{
            cursor: pointer;
            color:#5f4009;
            font-size:1.1rem;
            line-height: 1.7rem;
            /*border-bottom:1px solid #afa08a;*/

          }
        }
      }
      .fileitem:nth-child(3n){
        .fileitem_box{
          padding-right:0;
        }

      }
      .page{
        margin-top:2rem;
      }
    }
    .down_main{
      padding:2rem 2.8rem 2rem 2.8rem;
      box-sizing: border-box;
      margin-bottom:2rem;
      .down_txt{
        padding-right:3rem;
        display: flex;
        /*align-items: center;*/
        flex-direction: column;
        justify-content: center;
        height:100%;
        p{
          color:#5f4009;
          font-size:1.7rem;
          line-height: 3rem;
          margin:0;
        }
      }
      .towcode{
        display: flex;
        height:100%;
        align-items: center;
        img{
          display: block;
          width:11rem;
          height:11rem;
        }
      }
      .downtype{
        height:100%;
      }
      .down_type_box{
        height:100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        padding-left:4rem;
        .android{
          /*margin-top:2rem;*/
          background:url('../../../assets/images/android.png') no-repeat left center;
          background-size:2rem auto;
        }
        .ios{
          margin-top:2.6rem;
          background:url('../../../assets/images/ios.png') no-repeat left center;
          background-size:2rem auto;
        }
        .down-item{
          color:#5f4009;
          padding-left:2.9rem;
          font-size:1.4rem
        }
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/views/pc/download/index.vue